import React from 'react';
import { useTranslation } from 'react-i18next';
import { SiApple, SiGoogle } from 'react-icons/si';
import { SketchButton } from './sketchy';

interface RequireAccountModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLinkGoogle: () => void;
  onLinkApple: () => void;
}

const RequireAccountModal: React.FC<RequireAccountModalProps> = ({
  isOpen,
  onClose,
  onLinkGoogle,
  onLinkApple,
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50" data-testid="require-account-modal">
      <div className="bg-[var(--color-surface)] border border-[var(--color-border)] rounded-xl shadow-lg p-6 max-w-md w-full mx-4" role="dialog">
        <h2 className="text-xl font-bold text-[var(--color-text)] mb-2">
          {t('auth.requireAccount.title', 'Connect your account')}
        </h2>
        <p className="text-[var(--color-muted)] mb-4 text-sm">
          {t('auth.requireAccount.message', 'Connect a Google or Apple account to continue.')}
        </p>
        <div className="space-y-2">
          <SketchButton onClick={onLinkGoogle} className="w-full flex items-center justify-center gap-2" data-testid="link-account-google">
            <SiGoogle className="w-5 h-5" />
            {t('auth.continueWithGoogle')}
          </SketchButton>
          <SketchButton onClick={onLinkApple} className="w-full flex items-center justify-center gap-2" data-testid="link-account-apple">
            <SiApple className="w-5 h-5" />
            {t('auth.continueWithApple')}
          </SketchButton>
          <SketchButton variant="ghost" onClick={onClose} className="w-full mt-2">
            {t('buttons.cancel')}
          </SketchButton>
        </div>
      </div>
    </div>
  );
};

export default RequireAccountModal;
